exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".log-teaser-image {\n  background-color: var(--image-placeholder-color);\n}\n", ""]);

